import { twMerge } from 'tailwind-merge';

interface LoaderProps {
  containerClassName?: string;
  imageClassName?: string;
}

export const Loader = ({ containerClassName, imageClassName }: LoaderProps) => {
  return (
    <div
      className={twMerge(
        'fixed top-[50%] -translate-y-[50%] left-[50%] -translate-x-[50%] z-[99999]',
        containerClassName
      )}
    >
      <img className={twMerge('m-auto', imageClassName)} src="/loading.svg" />
    </div>
  );
};

export default Loader;
